import { createPrefixedActions } from '@zapier/toolbox-redux-framework/src/redux-utils';

export default createPrefixedActions(
  'entity',
  `
    INITIALIZE_COLLECTIONS

    RESET_COLLECTION
    RESET_COLLECTION_ENTITIES
    RESET_ENTITY_STATUS

    CREATE_COLLECTION_ENTITY
    DELETE_COLLECTION_ENTITIES
    UPDATE_COLLECTION_DATA
    UPDATE_COLLECTION_STATE

    FETCH_COLLECTION
    FETCH_COLLECTION_DONE
    FETCH_COLLECTION_FAIL

    SILENT_FETCH_COLLECTION
    SILENT_FETCH_COLLECTION_DONE
    SILENT_FETCH_COLLECTION_FAIL

    UPDATE_ENTITY_DATA
    UPDATE_ENTITY_STATE

    FETCH_ENTITY
    FETCH_ENTITY_DONE
    FETCH_ENTITY_FAIL
  `
);
